import fetch from "./fetch";
/**
 * 患者管理
 */
const patient = {
  //获取患者列表
  getPatientList(params) {
    return fetch({
      isLoading: true,
      url: "/kfjkPatient/page",
      method: "GET",
      params,
    });
  },

  //模糊搜索医生姓名
  remoteDoctorList(params) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/selectLike",
      method: "GET",
      params,
    });
  },

  //修改医生绑定关系
  updatePatientBind(data) {
    return fetch({
      isLoading: true,
      url: "/kfjkPatient/updateBind",
      method: "POST",
      data,
    });
  },

  //绑定关系分页
  getPatientBindList(params) {
    return fetch({
      isLoading: true,
      url: "/patientDoctorBind/page",
      method: "GET",
      params,
    });
  },
  //修改医生信息
  updatePatientInfo(data) {
    return fetch({
      isLoading: true,
      url: "/h5DmUser/update",
      method: "POST",
      data,
    });
  },
};

export default patient;
